import { type PropsWithChildren } from 'react';
import { useUser } from '@/lib/auth/useUser';
interface RenderConditionCheckerProps {
  shouldCheckRegistrationStatus?: boolean;
  shouldCheckAdmin?: boolean;
}

/**
 * 추가적인 렌더링 조건을 체크하는 컴포넌트
 * 등록 상태, 어드민 권한 등을 확인
 */
export const RenderConditionChecker = ({
  children,
  shouldCheckRegistrationStatus = false,
  shouldCheckAdmin = false
}: PropsWithChildren<RenderConditionCheckerProps>) => {
  const {
    user
  } = useUser();

  // 등록 상태 체크
  if (shouldCheckRegistrationStatus && !user?.registrationStatus) {
    return null;
  }

  // 어드민 권한 체크
  if (shouldCheckAdmin && !user?.admin) {
    return null;
  }
  return <>{children}</>;
};